// extracted by mini-css-extract-plugin
export default {"booklist_div":"Booklist_booklist_div__a5-dw","SearchDiv":"Booklist_SearchDiv__du5Q+"};